module.exports = __webpack_public_path__ + "img/chat-gpt-integration.aad62064.jpg";